module.exports = __webpack_public_path__ + "img/Notes.43724c28.svg";